import { render, staticRenderFns } from "./DialogOrdenarBens.vue?vue&type=template&id=62efc690&"
import script from "./DialogOrdenarBens.vue?vue&type=script&lang=js&"
export * from "./DialogOrdenarBens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports